import { createAction, props } from '@ngrx/store';

import { RestSurveyTemplate } from '@main-application/survey-creator/interfaces/survey-template';
import { RestTemplateAreaModel } from '@template/models/rest-template-model.interface';

/* Survey template */
export const loadSurveyTemplates = createAction('[Surveys] loadSurveyTemplates');
export const saveSurveyTemplate = createAction(
  '[Surveys] saveSurveyTemplate',
  props<{ id: number; template: string }>()
);

export const saveSurveyTemplateSuccess = createAction(
  '[Surveys] saveSurveyTemplateSuccess',
  props<{ templates: RestSurveyTemplate[] }>()
);

export const saveSurveyTemplateFailure = createAction('[Surveys] saveSurveyTemplateFailure', props<{ error: any }>());

export const loadSurveyTemplatesSuccess = createAction(
  '[Surveys] loadSurveyTemplatesSuccess',
  props<{ templates: RestSurveyTemplate[] }>()
);

export const loadSurveyTemplatesFailure = createAction('[Surveys] loadSurveyTemplatesFailure', props<{ error: any }>());

/* Inspection survey template */
export const addInspectionSurveyTemplate = createAction(
  '[Surveys] addInspectionSurveyTemplate',
  props<{ survey: RestTemplateAreaModel }>()
);

export const updateInspectionSurveyTemplate = createAction(
  '[Surveys] updateInspectionSurveyTemplate',
  props<{ survey: RestTemplateAreaModel }>()
);

export const saveInspectionSurveyTemplateSuccess = createAction(
  '[Surveys] saveInspectionSurveyTemplateSuccess',
  props<{ surveyId: number }>()
);

export const saveInspectionSurveyTemplateFailure = createAction(
  '[Surveys] saveInspectionSurveyTemplateFailure',
  props<{ error: any }>()
);
